/* eslint-disable react/prop-types */
import React, { Fragment, Component } from 'react';
import { format } from 'date-fns'
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';
import Typography from "@material-ui/core/Typography";
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import { DatePicker } from "@material-ui/pickers";
import CircularProgress from '@material-ui/core/CircularProgress';
import { alphabetExp, numberExp, emailExp } from '../../../../utils/regularExpression';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { Link } from 'react-router-dom';
import LoginMenu from '../../../../components/LoginMenu/LoginMenu';

const styles = () => ({
    root: {
        padding: 20,
    },
    formControl: {
        minWidth: '100%',
    },
    sectionTitle: {
        fontSize: 19,
        color: '#174a84',
    },
    checkboxDividerLabel: {
        marginTop: 10,
        marginLeft: 5,
        marginRight: 20,
        fontSize: 16,
        fontWeight: 600
    },
    rootProgress: {
        width: '100%',
        textAlign: 'center',
    },
});

function isEmpty(obj) {

    if (obj == null) return true;

    if (typeof obj !== "object") return true;

    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

class NewAdmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
           newAppliedFor: "",
           degreeData: [],
           successDialog: false,
        }
    }

    componentDidMount() {
        this.getDegreesData();
    }

    handleSuccessDialog = () => {
        this.setState({
            successDialog: !this.state.successDialog,
        });
    }
    handleOnClick = () => {
        // if (this.isFormValid()) {
            document.getElementById('submit-button').click();
        // }
    }


    getDegreesData = async () => {
        let data = [];
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonAcademicsDegreeProgramsView`;
        await fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    const resData = json.DATA || [];
                    if (resData.length > 0) {
                        for (let i = 0; i < resData.length; i++) {
                            if (!isEmpty(resData[i])) {
                                data.push({ id: "", label: resData[i].department })
                            }
                            for (let j = 0; j < resData[i].degrees.length; j++) {
                                if (!isEmpty(resData[i].degrees[j])) {
                                    data.push({ id: resData[i].degrees[j].id, label: resData[i].degrees[j].label })
                                }
                            }
                        }
                    }
                },
                error => {
                    console.log('myData', error);
                });
        this.setState({
            degreeData: data
        });
    }
    handleChange = e => {
        const { name, value } = e.target;
        const errName = `${name}Error`;
        console.log(name, value)
        this.state.newAppliedFor = value;
    }


    onFormSubmit = async () => {
        // preventDefault();
        if (this.state.newAppliedFor==null || this.state.newAppliedFor=="") {
            alert("Programme is required");
            return false;
          }
        const data = new FormData();
       data.append("degreeId", this.state.newAppliedFor);
        this.setState({
            isLoading: true
        })
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectNewApplication`;
        await fetch(url, {
            method: "POST", body: data, headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        // window.localStorage.setItem("isSaved", 1);
                        // window.localStorage.setItem("applicationId", json.DATA[0].ApplicationId);
                        // document.body.scrollTop = 0;
                        // document.documentElement.scrollTop = 0;
                        // this.handleSuccessDialog();
                        alert("Your degree has been changed. Please fill the form.");
                        window.localStorage.setItem("isSubmitted", 0);
                        window.localStorage.setItem("isDocumentRequested", 0);
                        window.localStorage.setItem("isPreviousSessionStudent", 0);
                        window.location.replace("#/dashboard/admission-application");
                        window.location.reload();
                        // window.location=`#/dashboard/admission-application`;
                    } else {
                        alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE)
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        this.setState({
                            isLoginMenu: true,
                            isReload: false
                        })
                    } else {
                        console.log(error);
                        alert("Failed to Save ! Please try Again later.")
                    }
                });
        this.setState({
            isLoading: false
        })
    }

    render(){
        const { classes } = this.props;
        return (
            <Fragment>
                <Grid container component="main" className={classes.root}>
                <Typography style={{
                        color: '#1d5f98', 
                        fontWeight: 600, 
                        borderBottom: '1px solid #d2d2d2',
                        width: '98%', 
                        marginBottom: 25, 
                        fontSize: 20,
                        
                    }} variant="h5">
                       New Admission
                    </Typography>
                    <Divider style={{
                        backgroundColor: 'rgb(58, 127, 187)',
                        opacity: '0.3'
                    }} />
                    <Grid container spacing={2} style={{ marginLeft: 5, marginRight: 10 }}>
                    <Grid xs={12}>
                            <span className={classes.sectionTitle}>
                                Course Applied For
                            </span>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl error={!!this.state.newAppliedForError} className={classes.formControl}>
                                <InputLabel htmlFor="newAppliedFor">Programme</InputLabel>
                                <Select name="newAppliedFor" id="newAppliedFor" onChange={this.handleChange}>
                                    {this.state.degreeData.map((item, index) => {
                                        return (<MenuItem key={index} disabled={!item.id} value={item.id}>{item.label}</MenuItem>);
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ paddingBottom: 20, paddingTop: 20, display: 'flex' }} justify="center">
                    <Button disabled={this.state.isLoading} onClick={this.onFormSubmit} color="primary" variant="contained" style={{ width: '100%', backgroundColor: '#174A84' }}>
                        {this.state.isLoading ? <CircularProgress style={{ color: 'white' }} size={24} /> : "Save"}
                    </Button>
                </Grid>
            </Fragment >
        );
    }
}


export default withStyles(styles)(NewAdmission);
